import BasePage from '../../components/base-page/base-page';

import './author.scss';


class Author extends BasePage {}

export default Author;

(Author as BasePage).initOnDomLoaded();
